// Notification Service for displaying messages to users
class NotificationService {
  constructor() {
    this.notifications = [];
    this.listeners = [];
  }

  // Add a notification
  addNotification(notification) {
    const id = Date.now() + Math.random();
    const newNotification = {
      id,
      type: notification.type || 'info', // success, error, warning, info
      title: notification.title || '',
      message: notification.message || '',
      duration: notification.duration || 5000, // 5 seconds default
      timestamp: new Date(),
    };

    this.notifications.push(newNotification);
    this.notifyListeners();

    // Auto remove after duration
    if (newNotification.duration > 0) {
      setTimeout(() => {
        this.removeNotification(id);
      }, newNotification.duration);
    }

    return id;
  }

  // Remove a notification
  removeNotification(id) {
    this.notifications = this.notifications.filter(n => n.id !== id);
    this.notifyListeners();
  }

  // Clear all notifications
  clearAll() {
    this.notifications = [];
    this.notifyListeners();
  }

  // Get all notifications
  getNotifications() {
    return [...this.notifications];
  }

  // Subscribe to notification changes
  subscribe(listener) {
    this.listeners.push(listener);
    return () => {
      this.listeners = this.listeners.filter(l => l !== listener);
    };
  }

  // Notify all listeners
  notifyListeners() {
    this.listeners.forEach(listener => listener(this.notifications));
  }

  // Convenience methods
  success(title, message, duration = 5000) {
    return this.addNotification({
      type: 'success',
      title,
      message,
      duration,
    });
  }

  error(title, message, duration = 7000) {
    return this.addNotification({
      type: 'error',
      title,
      message,
      duration,
    });
  }

  warning(title, message, duration = 5000) {
    return this.addNotification({
      type: 'warning',
      title,
      message,
      duration,
    });
  }

  info(title, message, duration = 5000) {
    return this.addNotification({
      type: 'info',
      title,
      message,
      duration,
    });
  }

  // Show loading notification
  loading(title, message) {
    return this.addNotification({
      type: 'loading',
      title,
      message,
      duration: 0, // Don't auto-remove
    });
  }
}

// Create and export a singleton instance
const notificationService = new NotificationService();
export default notificationService;
